export const GET_KICKSTART_RESPONCE_SUCCEED = 'Questionnaire/GET_KICKSTART_RESPONCE_SUCCEED';
export const GET_KICKSTART_RESPONCE_ERROR = 'Questionnaire/GET_KICKSTART_RESPONCE_ERROR';
export const LOADING_STATE = 'Questionnaire/LOADING_STATE';